export default {
  state: {
    asapSuccess: {
      show: false,
      rsvpId: '',
      driver: {
        id: '',
        name: '',
        mobile: '',
        rating: '',
        img: ''
      },
      vehicle: {
        img: '',
        year: '',
        make: '',
        model: '',
        licensePlate: '',
        color: ''
      }
    }
  },
  mutations: {
    setAsapSuccessData (state, data) {
      for (let field in data) {
        state.asapSuccess[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/global/asapSuccess.js